import apiClient, { safeJson } from '@/api/client';
import { TicketTransfer, TicketTransferOption, TransferTicketBody } from './types';

export const getTicketTransferOptions = async ({
    centerId,
    memberId,
}: {
    centerId: string;
    memberId: string;
}) => {
    const res = await apiClient.get(`v1/centers/${centerId}/members/${memberId}/ticket-transfer-options`);
    return {
        status: res.status,
        data: await safeJson(res) as { success: boolean; results: TicketTransferOption[] } | null,
    };
};

export const transferTicket = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: TransferTicketBody;
}) => {
    const res = await apiClient.post(`v1/centers/${centerId}/ticket-transfers`, { json: body });
    return {
        status: res.status,
        data: await safeJson(res) as {
            success: boolean;
            transfer: TicketTransfer;
            source: any;
            target: any;
            /** 같은 멱등 키의 재요청이라 서버가 아무것도 다시 쓰지 않고 첫 결과를 돌려줬다. 성공이다. */
            idempotentReplay?: boolean;
        } | null,
    };
};

export const getTicketTransfers = async ({
    centerId,
    params,
}: {
    centerId: string;
    params?: Record<string, string>;
}) => {
    const res = await apiClient.get(`v1/centers/${centerId}/ticket-transfers`, { searchParams: params });
    return {
        status: res.status,
        data: await safeJson(res) as { success: boolean; results: TicketTransfer[]; totalResults: number } | null,
    };
};

